<script lang="ts" setup>
import { computed, onMounted, onUnmounted, ref, watch } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import emojiData from '../../emojiData.ts';
import { EmojiActionService } from './EmojiAction.service';

const emojiActionService = useService(EmojiActionService);

const props = defineProps<{ selectEmoji?: (char: string) => void }>();
const emojiTypeList = [
  'People',
  'Nature',

  // 'Objects', 'Places', 'Symbols'
];
const EmojiNameMap = {
  People: '默认',
  Nature: '自然',
  Objects: '物体',
  Places: '地点',
  Symbols: '符号',
};
console.log(emojiTypeList);
const defaultEmojiType = emojiTypeList[0];
const activeEmojiType = ref(defaultEmojiType);
const emojiList = computed(() => {
  const finalList = emojiData.find((emoji) => {
    return emoji.name.includes(activeEmojiType.value);
  })?.emojis;
  return finalList;
});
function handleSelectEmoji(e: any) {
  emojiActionService.visible = false;
  props.selectEmoji?.(e.char);
  // 记录用户选择的emoji
  window.hetaoTrack('oj_im_emoji_selected', { sub_type: e.code });
}
function handleSelectEmojiType(emojiType: string) {
  activeEmojiType.value = emojiType;
}
function handleClose() {
  emojiActionService.visible = false;
}
watch(
  () => emojiActionService.visible,
  (visible) => {
    if (visible) {
      //加个延迟避免点击emoji按钮时触发,nextTick无效
      setTimeout(() => {
        document.addEventListener('click', handleClose);
      }, 0);
    } else {
      document.removeEventListener('click', handleClose);
    }
  },
);
</script>

<template>
  <div
    v-show="emojiActionService.visible"
    class="absolute bottom-full left-0 mb-[1px] flex h-[200px] w-full flex-col rounded-t bg-[#F4F4F2] pt-2"
    @click.stop
  >
    <div class="hetao-scrollbar flex flex-1 flex-wrap overflow-y-auto pl-3">
      <div
        v-for="emoji in emojiList"
        :key="emoji.no"
        class="flex-center h-12 w-12 cursor-pointer text-[34px]"
        @click="handleSelectEmoji(emoji)"
      >
        {{ emoji.char }}
      </div>
    </div>
    <div class="flex h-[40px] items-center rounded-t bg-white px-2">
      <span
        v-for="emojiType in emojiTypeList"
        :key="emojiType"
        :class="{ checked: activeEmojiType === emojiType }"
        size="small"
        class="btn cursor-pointer"
        type="primary"
        @click="handleSelectEmojiType(emojiType)"
        >{{ EmojiNameMap[emojiType as keyof typeof EmojiNameMap] }}</span
      >
    </div>
  </div>
</template>
<style scoped>
.btn {
  @apply flex-center h-6 rounded-[20px] px-4 text-sm;
}
.checked {
  @apply text-colorText !bg-[#F4F4F2];
}
</style>
